import React from "react"
import { Link } from "react-router-dom"
import { ArrowRight } from "lucide-react"
import SectionHeading from "../home/SectionHeading.jsx"
import { SERVICE_ICONS } from "./serviceIcons.js"
import { SERVICES, SERVICES_HUB, serviceHref } from "../../data/services.js"

// Compact links to the other core services, for cross-linking service pages.
export default function RelatedServices({ exclude, title = "Related services", tone = "muted" }) {
  const services = SERVICES.filter((service) => service.key !== exclude)

  return (
    <section
      aria-labelledby="related-services-heading"
      className={`py-16 sm:py-20 ${tone === "muted" ? "bg-brand-bg" : "bg-white"}`}
    >
      <div className="mx-auto max-w-6xl px-4 sm:px-6">
        <div className="flex flex-col gap-4 sm:flex-row sm:items-end sm:justify-between">
          <SectionHeading id="related-services-heading" title={title} />
          <Link
            to={SERVICES_HUB}
            className="inline-flex shrink-0 items-center gap-2 font-semibold text-brand-primary hover:underline"
          >
            All services
            <ArrowRight aria-hidden="true" className="h-4 w-4" />
          </Link>
        </div>

        <ul className="mt-8 grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {services.map((service) => {
            const Icon = SERVICE_ICONS[service.icon]

            return (
              <li key={service.key}>
                <Link
                  to={serviceHref(service)}
                  className="flex h-full items-center gap-4 rounded-xl2 border border-brand-border bg-white p-5 shadow-card transition hover:shadow-cardStrong focus:outline-none focus-visible:ring-2 focus-visible:ring-brand-primary focus-visible:ring-offset-2"
                >
                  <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-xl bg-brand-primarySoft text-brand-primary">
                    {Icon && <Icon aria-hidden="true" className="h-5 w-5" />}
                  </span>
                  <span className="font-semibold text-brand-heading">{service.title}</span>
                </Link>
              </li>
            )
          })}
        </ul>
      </div>
    </section>
  )
}
